import GrowthBookApp from "./GrowthBookApp";

export default GrowthBookApp;
